const slogans = [
  "iCare: Your loved ones, cared for.",
  "iCare: Distance doesn't matter.",
  "iCare: Peace of mind, anytime, anywhere.",
  "iCare: Connecting families, bridging distances.",
  "iCare: Your remote care solution, bringing comfort and security.",
  "iCare: Empowering independence, one connection at a time.",
  "iCare: Because family is always close, even when they're far.",
  "iCare: A helping hand, wherever you are.",
  "iCare: Keeping your loved ones safe and loved."
];


export const GetSlogan = () => (
  <p style={{textAlign: 'center'}}>
    {slogans[Math.floor(Math.random() * slogans.length)]}
  </p>
)